import instanceQuery from '../../queries/product/ProductPriceMatrixQuery.graphql';
import temporaryInstanceQuery from '../../queries/product/ProductPriceMatrixTemporaryQuery.graphql';
import workspaceQuery from '../../queries/product/ProductPriceMatrixWorkspaceQuery.graphql';
import defaultQuery from '../../queries/product/ProductPriceMatrixDefault.graphql';
import listQuery from '../../queries/product/ProductPriceMatrixListQuery.graphql';
import mutationQuery from '../../mutations/product/ProductPriceMatrixMutation.graphql';
import temporaryMutationQuery from '../../mutations/product/ProductPriceMatrixTemporaryMutation.graphql';
import fragment from '../../fragments/product/ProductPriceMatrixFragment.graphql';

import { workspaceActionsForPermissions, formActions } from '../../../actions/product/ProductPriceMatrixAction';
import { EntityType } from '../../../@types/entityTypes';

const ProductPriceMatrix: EntityType = {
  type: 'ProductPriceMatrix',
  title: 'Product Price Matrices',
  formTitle: 'Product Price Matrix',
  formUrl: '/Sales/CustomerPricing/ProductPriceMatrix/Details/',
  workspaceUrl: '/Sales/CustomerPricing/ProductPriceMatrix/Workspace',
  instance: instanceQuery,
  temporaryInstance: temporaryInstanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  list: listQuery,
  fragment,
  screenReference: 'PRODUCT_PRICE_MATRICES',
  actions: [...workspaceActionsForPermissions, ...formActions],
};

export default ProductPriceMatrix;
